import React from "react";
import { Button } from "semantic-ui-react";

interface Props {
  height: number
}

const Invoice = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const onButtonClick = async () => {
    setIsLoading(true);
    await window.CoreApi.Subscription.SetClientPaymentMethodToInvoice();
    window.location.reload();
  };

  return <div>
    <div style={{ height: props.height }} className="flex-column align-center justify-center lightblue-bg s1_blue">
      <div className="margin-bottom-large" style={{ maxWidth: 600, textAlign: "center", lineHeight: "1.5em" }}>
        Since June 2022 we are offering an automated billing option.<br />
        During a transitional period, we allow annual subscriptions to be paid per invoice.<br />
        However, it&apos;s preferred that you switch to an automated payment method.
      </div>
    </div>

    <div className="flex justify-end margin-top-large">
      <div className="grow1 margin-right">
      </div>
      <div>
        <Button onClick={onButtonClick} disabled={isLoading} primary>{RESX.Buttons.btnSave}</Button>
      </div>
    </div>
  </div>;
};

export default Invoice;